import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './CloudSecurity.css';

const CloudSecurity = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  return (
    <div className="cloud-security-page-wrapper">
      <div className="cloud-security-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'Cloud Security')}
        />

        <div className="cloud-security-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="cloud-security-page-hero">
          <h1>Cloud Services Security</h1>
          <p>
            BlackRoth delivers robust Cloud Security services that protect
            cloud infrastructure, applications, and data from threats while
            ensuring compliance, scalability, and operational resilience.
          </p>
        </div>

        <section className="cloud-security-page-section">
          <h2>Overview</h2>
          <p>
            Cloud environments introduce unique security challenges.
            BlackRoth provides comprehensive cloud security strategies that
            safeguard workloads across public, private, and hybrid cloud
            platforms without compromising performance or agility.
          </p>
        </section>

        <section className="cloud-security-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our Cloud Security solutions are designed to prevent unauthorized
            access, protect sensitive data, and maintain compliance across
            complex cloud architectures.
          </p>
        </section>

        <section className="cloud-security-page-section">
          <h2>Services We Offer</h2>
          <ul className="cloud-security-service-list">
            <li>Cloud Security Architecture & Consulting</li>
            <li>Identity & Access Management (IAM)</li>
            <li>Cloud Infrastructure Protection</li>
            <li>Data Encryption & Key Management</li>
            <li>Cloud Compliance & Risk Management</li>
            <li>Threat Detection & Incident Response</li>
            <li>Secure DevOps & Cloud-Native Security</li>
            <li>Continuous Monitoring & Auditing</li>
          </ul>
        </section>

        <section className="cloud-security-page-section">
          <h2>Industry Use Cases</h2>
          <p>
            BlackRoth's Cloud Security services support organizations across
            finance, healthcare, SaaS, e-commerce, government, and enterprise
            IT environments by ensuring secure and compliant cloud adoption.
          </p>
        </section>

        <section className="cloud-security-page-section">
          <h2>Technology Stack</h2>
          <p>
            We work with leading cloud platforms and security tools including
            AWS, Azure, GCP security services, cloud firewalls, SIEM systems,
            CASB solutions, and zero-trust architectures.
          </p>
        </section>

        <section className="cloud-security-page-section">
          <h2>Compliance & Governance</h2>
          <p>
            BlackRoth ensures cloud security implementations align with global
            standards such as ISO, SOC 2, GDPR, HIPAA, and industry best
            practices for governance and risk management.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CloudSecurity;

